import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    // Edit
    recommendation: undefined,
};

export default createReducer(initial, {
    [actions.updateActiveRecommendation]: (state, action) => {
        return { ...state, recommendation: action.payload };
    },
    [actions.updateActiveRecommendationCropConfig]: (state, { payload: { key, value } }) => {
        const crop = state.recommendation.crops?.[0];
        const newCrop = { ...crop, [key]: value };
        return { ...state, recommendation: { ...state.recommendation, crops: [newCrop] } };
    },
});
